import {
  CartItemActionsTranslation,
  CartItemDetailsTranslation,
  CartSummaryTranslation,
  RolesTranslation,
  ShoppingCartItemBasicInfoTranslation,
  ShoppingCartItemPanelTranslation,
  SiteTranslation,
} from './SiteTranslation';
import { ActionMenuTranslation } from '../../app/localization/SiteTranslation';
import baseTranslation from '../../app/localization/pl-pl';

const actionMenuTranslation: ActionMenuTranslation = {
  title: 'Akcje',
};

const cartItemActionsTranslation: CartItemActionsTranslation = {
  actionMenu: actionMenuTranslation,
};

const shoppingCartItemBasicInfoTranslation: ShoppingCartItemBasicInfoTranslation = {
  cartItemDetails: {
    configCodeLabel: 'Kod konfiguracyjny',
    noItemsLabel: 'Liczba produktów',
    listPriceLabel: 'Cena katalogowa',
    netPriceLabel: 'Twoja cena netto',
  },
};

const shoppingCartItemPanelTranslation: ShoppingCartItemPanelTranslation = {
  cartItemActions: cartItemActionsTranslation,
};

const cartSummaryTranslation: CartSummaryTranslation = {
  priceBeforeVatLabel: 'Cena bez VAT-u',
  vatLabelFormat: 'Vat ({taxRate}%)',
  priceIncludingVatLabel: 'Cena z VAT-em',
  deliveryFeeLabel: 'Cena dostawy',
  noItemsLabel: 'Liczba przedmiotów',
  subtotalHeader: 'Suma',
  accordingToAgreementText: 'Zgodnie z umową',
  surchargesAnnotationText: 'Dodatkowe opłaty mogą zostać doliczone do zamówienia. Szczegóły będą podane na fakturze.',
};

const cartItemDetailsTranslation: CartItemDetailsTranslation = {
  configCodeLabel: 'Kod konfiguracyjny',
  noItemsLabel: 'Liczba przedmiotów',
  listPriceLabel: 'Cena katalogowa',
  netPriceLabel: 'Twoja cena netto',
};

const rolesTranslation: RolesTranslation = {
  admin: 'Administrator',
  buyer: 'Buyer',
  flokkSales: 'Flokk Sales',
  flokkSupport: 'Flokk Support',
  flokkDigital: 'Flokk Digital',
  reader: 'Reader',
};

const translation: SiteTranslation = {
  ...baseTranslation,
  ...{
    b2bHomePage: {
      pageTitleFormat: '',
      pageDescriptionFormat: '',
      onboarding: {
        headerText: 'Witaj',
        welcomeText: "Cieszymy się, że mamy Cię na pokładzie. Poniżej znajdziesz wskazówki, które pomogą Ci zacząć.",
        onboardingCards: {
          configureChairTitle: 'Skofiguruj krzesło',
          configureChairText: 'Skofiguruj krzesło',
          placeAnOrderTitle: 'Złóż zamówienie',
          placeAnOrderText: 'Złóż zamówienie',
          manageAndTrackTitle: 'Zarządzaj i śledź',
          manageAndTrackText: 'Zarządzaj i śledź',
          selectAChairTextPart1: 'Wybierz krzesło w ',
          selectAChairTextPart2: 'Produkty',
          selectAChairTextPart3: ' i dostosuj je w konfiguratorze do potrzeb Twojego klienta.',
          addConfigToFavoritesTextPart1: 'Możesz dodać swoją konfiguracje do ',
          addConfigToFavoritesTextPart2: 'Ulubione',
          placeChairToCartTextPart1: 'Kiedy Twoje krzesło będzie gotowe do zamówienia włóż je do Twojego ',
          placeChairToCartTextPart2: 'Koszyk',
          manageOngoingOrdersTextPart1: 'Możesz łatwo zarządzać aktualnymi zaówieniami w ',
          manageOngoingOrdersTextPart2: 'Historia zamówień',
          manageOngoingOrdersTextPart3: ', a także przeglądać poprzednie zamówienia.',
          receiveNotificationsFromTrackingText:
            'Poprzez system powiadomień będziesz otrzymywał informację po każdej zmianie statusu zamówienia.',
        },
      },
    },
    profilePage: {
      pageTitleFormat: '',
      pageDescriptionFormat: '',
      personalTabTitle: 'Informacje',
      usersTabTitle: 'Użytkownicy',
      roles: rolesTranslation,
      personalTabContent: {
        emailLabel: 'Email',
        emailNotificationsHeader: 'Powiadomienia e-mail',
        emailNotifications: {
          orderCreated: 'Zamówienie utworzone',
          orderStatusChanged: 'Zmiana statusu zamówienia',
          orderCancelled: 'Zamówienie anulowane',
          orderNotifyOnlyMyOrders: 'Tylko moje zamówienia',
        },
        firstNameLabel: 'Imię',
        lastNameLabel: 'Nazwisko',
        phoneNumberLabel: 'Numer telefonu',
        saveChangesButton: 'Zapisz zmiany',
        basicInformationHeader: 'Podstawowe informacje',
        languageSelectorLabel: 'Język',
        languages: {
          deDe: 'niemiecki',
          enGb: 'angielski',
          frFr: 'francuski',
          nlNl: 'niderlandzki',
          plPl: 'polski'
        },
        passwordResetBlock: {
          passwordResetHeader: 'Zresetuj hasło',
          emailSentText: 'Wysłaliśmy e-mail z resetem hasła. Sprawdź proszę swoją skrzynkę pocztową.',
          sendPasswordResetEmailAgainText: 'Wyślij ponownie e-mail z resetem hasła',
          sendPasswordResetEmailText: 'Wyślij e-mail z resetem hasła',
          confirmPasswordResetHeader: 'Potwierdź zresetowanie hasła',
          areYouSureResetPasswordText: 'Czy na pewno chcesz zresetować hasło?',
          cancelButton: 'Anuluj',
          yesButton: 'Tak',
        },
      },
      usersTab: {
        removeUserTitle: 'Usuń użytkownika',
        inviteNewUserButton: 'Zaproś nowego użytkownika',
        editRolesLabel: 'Edytuj role',
        removeLabel: 'Usuń',
        removeContactFromOrganisationTextPart1: 'Czy jesteś pewny, że chcesz usunąć ',
        removeContactFromOrganisationTextPart2: ' z Twojej organizacji?',
        invitationsTable: {
          pendingInvitationsHeader: 'Oczekujące zaproszenia',
          userNameHeader: 'Nazwa użytkownika',
          emailHeader: 'Email',
          expiresAtHeader: 'Wygasa',
          contextMenuHeader: '',
          removeLabel: 'Usuń',
          actionMenu: actionMenuTranslation,
        },
        usersTable: {
          rolesHeader: 'Role',
          userNameHeader: 'Nazwa użytkownika',
          contextMenuHeader: '',
          roles: rolesTranslation,
        },
        inviteNewUsersModal: {
          inviteNewUserHeader: 'Zaproś nowego użytkownika',
          firstNameLabel: 'Imię',
          lastNameLabel: 'Nazwisko',
          emailLabel: 'Email',
          repeatEmailLabel: 'Powtórz email',
          grantedRolesLabel: 'Przyznane role',
          sendInvitationButton: 'Wyślij zaproszenie',
          roles: rolesTranslation,
        },
        confirmInvitationRemovalModal: {
          areYouSureRemoveInvitationText: 'Czy jesteś pewny, że chcesz usunąć zaproszenie dla ',
          title: 'Usuń zaproszenie',
        },
        changeUserRolesModal: {
          selectRolesText: 'Wybierz role dla',
          title: 'Edytuj role',
          roles: rolesTranslation,
        },
        actionMenu: actionMenuTranslation,
      },
    },
    invitationPage: {
      pageTitleFormat: '',
      pageDescriptionFormat: '',
      headerText: 'Zostałeś zaproszony do Flokk HUB!',
      loggedAsText: 'Obecnie jesteś zalogowany do Flokk Hub jako',
      useCurrentAccountOrCreateNewText:
        'Czy chcesz użyć obecnego konta czy utworzyć nowe, aby zakończyć proces?',
      useCurrentAccountButton: 'Użyj obecnego konta',
      createNewAccountButton: 'Stwórz nowe konto',
      fullfillInvitationText:
        'Aby dokończyć proces, na następnym ekranie będziesz musiał zalogować się przy użyciu istniejącego konta lub zarejestrować się, aby utworzyć nowe konto.',
      signUpForFlokkHub: 'Zarejestruj się w Flokk Hub',
      haveAccountInformationText: 'Jeśli masz już konto w Flokk Hub, możesz z niego skorzystać',
      logInWithExistingAccountText: 'Zaloguj się na istniejące konto',
      expiredInvitationInformationText:
        'Twoje zaproszenie wygasło. Poproś zespoł Flokk o wysłanie nowego zaproszenia',
      invitationLinkNotValidText: 'Twój link aktywacyjny jest niepoprawny',
      invitationLinkNotValidInformationText:
        'Zaproszenie, którego próbujesz użyć, nie istnieje. Sprawdź czy użyty link jest tym wysłanym przez Flokk.',
      ifProblemStillOccursContactFlokkText: 'Jeśli problem nadal występuje, skontaktuj się z zespołem Flokk, aby otrzymać nowe zaproszenie.',
      somethingWrongWithInvitationText: 'Coś poszło nie tak z Twoim zaproszeniem',
      notAbleToProcessRequestText:
        'Nie możemy przetworzyć Twojego żądania. Spróbuj ponownie później lub skontaktuj się z zespołem Flokk.',
    },
    catalogPage: {
      ...baseTranslation.catalogPage,
      exploreAllItems: 'Zobacz wszystkie konfiguracje',
      familyItemAvailabilityModal: {
        closeButton: 'Zamknij',
        familyItemIsAvailableOnlyForConfiguration:
          'Ten produkt nie jest obecnie dostępny do kupienia za pośrednictwem Flokk Hub. Nadal możesz go skonfigurować i dodać do ulubionych.',
        familyItemIsUnavailable: 'Tego produktu nie można jeszcze skonfigurować ani kupić za pośrednictwem Flokk Hub.',
      },
      filterBar: {
        ...baseTranslation.catalogPage.filterBar,
        results: "Rodziny produktów: {results}",
      }
    },
    cartPage: {
      pageTitleFormat: '',
      pageDescriptionFormat: '',
      orderSummaryText: 'Podsumowanie zamówienia',
      goBackButton: 'Wróć',
      deliveryAddressText: 'Adres dostwawy',
      deliveryInstructionsLabel: 'Instrukcje dotyczące dostawy, widoczne na etykiecie przesyłki',
      deliveryInstructionsPlaceholder: 'Np. drugie piętro',
      placeOrderButton: 'Złóż zamówienie',
      cartList: {
        sendByEmailButton: 'Wyślij e-mailem',
        placeOrderButton: 'Złóż zamówienie',
        editProductLabel: 'Edytuj produkt',
        removeFromCardLabel: 'Usuń z koszyka',
        cartOverviewTitle: 'Podsumowanie koszyka',
        cartSummaryTitle: 'Podsumowanie koszyka',
        downloadImagesLabel: 'Pobierz wizualizacje',
        noneOrdersSelectedLabel: 'Żadne zamówienie nie zostało wybrane',
        continueWithOrdersLabelFormat: 'Kontynuj z {ordersCount} zamówieniami',
        placeAllOrdersLabelFormat: 'Złóż wszystkie {ordersCount} zamówienia',
        cart: 'Koszyk',
        cartSummary: cartSummaryTranslation,
        cartHeader: {
          readyForShippingText: 'Gotowe do wysyłki w ciągu {minDays} - {maxDays} dni roboczych',
        },
        cartItemList: {
          cartItem: {
            cartItemActions: cartItemActionsTranslation,
            cartItemBodyDetails: {
              removeItemButton: 'Usuń produkt',
              updateQuantityButton: 'Zmień ilość',
              revertButton: 'Cofnij',
              cartItemDetails: cartItemDetailsTranslation,
            },
          },
        },
      },
      orderSummary: {
        brandLabel: 'Marka',
        noItemsLabel: 'Liczba produktów',
        readyForShippingFromFactoryLabel: 'Gotowe do wysłania z fabryki',
        readyForShippingFromFactoryValue: '{minDays} - {maxDays} dni roboczych',
        customReferenceLabel: 'Twój numer referencyjny',
        customReferencePlaceholder: 'Np. Twój numer zamówienia',
        customNameLabel: 'Nazwa zamówienia',
        customNamePlaceholder: 'Np. nazwa klienta',
        commentLabel: 'Komentarz',
        commentPlaceholder: '',
      },
      deliveryAddress: {
        addButton: 'Wprowadź nowy adres',
        editButton: 'Edytuj',
        deliveryAddressForm: {
          city: {
            name: 'Miasto',
            fieldRequired: 'Miasto jest wymagane',
          },
          country: {
            name: 'Kraj',
          },
          zipCode: {
            name: 'Kod pocztowy',
            fieldRequired: 'Kod pocztowy jest wymagany',
            wrongFormat: 'Podany kod pocztowy jest nieprawidłowy',
          },
          addressLine1: {
            name: 'Adres',
            fieldRequired: 'Adres jest wymagany',
          },
          addressLine2: {
            name: 'Adres 2 (opcjonalnie)',
          },
          recipient: {
            name: 'Odbiorca',
            fieldRequired: 'Odbiorca jest wymagany',
          }
        },
      },
      cartSummary: cartSummaryTranslation,
      orderCreationConfirmationModal: {
        title: 'Czy na pewno chcesz kontynuować?',
        confirmationText: 'Składasz zamówienie w imieniu',
        confirmButton: 'Złóż zamówienie',
        cancelButton: 'Anuluj',
      },
      orderCreatedModal: {
        somethingWentWrongTitle: 'Coś poszło nie tak',
        notAllOrdersCreatedSuccessfullyTitle:
          'Coś poszło nie tak. Tylko  {succedeedOrdersCount} z ${totalOrdersCount} zostało pomyślnie utworzonych',
        technicalIssuesSubtitle: "Z powodu problemów technicznych nie możemy utworzyć zamówienia z następującymi konfiguracjami:",
        orderCreatinFailedSubtitle: 'Utworzenie zamówienia nie powiodło się. Spróbuj ponownie lub skontaktuj się z zespołem wsparcia Flokk Hub.',
        notAllOrdersCreatedSuccessfullySubtitle:
          'Pomyślnie utworzono zamówienia: {succedeedOrders}.\nNie udało się utworzyć:  {failedOrders}.\n Proszę spróbować ponownie lub skontaktować się z zespołem wsparcia technicznego Flokk Hub.',
        OrderCreatedSuccessNotification: {
          ongoingOrdersLabel: 'Zobacz bieżące zamówienia',
          orderDetailsLabel: 'Zobacz szczegóły zamówienia',
          orderReceivedTitle: 'Dziękujemy! Otrzymaliśmy Twoje zamówienie.',
          orderReceivedSubtitle:
            'Potwierdzenie zamówienia zostanie wysłane na Twój adres e-mail, gdy zamówienie zostanie przekazane do produkcji.',
        },
      },
      sendCartToEmail: {
        headerText: 'Wyślij wybrane produkty na adres e-mail',
        sendButton: 'Wyślij',
        emailLabel: 'Email',
      },
    },
    configurationPage: {
      ...baseTranslation.configurationPage,
      priceTaxText: '(bez VAT-u)',
    },
    configuratorActions: {
      addToCartButton: 'Dodaj do koszyka',
      favoriteButton: {
        addToFavoritesText: 'Dodaj do ulubionych',
        addingToFavoritesText: 'Dodawanie do ulubionych...',
        addedToFavoritesText: 'Dodano do ulubionych',
        addingToFavoritesFailed: 'Nie można dodać produktu do ulubionych. Upewnij się, że jest dostępny w Twoim kraju.',
      },
      updateCartItemButton: 'Zaktualizuj produkt w koszyku',
      addedToCartModal: {
        updatedInCartHeader: 'Zaktualizowano w koszyku',
        addedToCartHeader: 'Dodano do koszyka',
        goToCartButton: 'Idź do koszyka',

        quantityInfo: {
          productAddedText: 'dodano 1 produkt',
          productsAddedText: 'dodano {quantityAdded} produktów',
        },
        addedToCartItem: {
          cartItemPreview: {
            cartItemDetails: cartItemDetailsTranslation,
          },
          cartItemSubtotal: {
            exclValText: '(bez VAT-u)',
            subtotalText: 'Suma',
          },
        },
      },
    },
  },
  favoritesPage: {
    title: 'Moje ulubione',
    downloadImagesLabel: 'Pobierz wizualizacje',
    editNameLabel: 'Edytuj nazwę',
    removeLabel: 'Usuń',
    searchInputLabel: 'Szukaj',
    searchInputPlaceholder: 'Nazwa produktu lub kod konfiguracji',
    sortBySelectLabel: 'Sortuj po',
    sortByNameAscLabel: 'Nazwa (A-Z)',
    sortByNameDescLabel: 'Nazwa (Z-A)',
    sortByDateAscLabel: 'Data dodania (najstarsze)',
    sortByDateDescLabel: 'Data dodania (najnowsze)',
    sortByPriceAscLabel: 'Cena (rosnąco)',
    sortByPriceDescLabel: 'Cena (malejąco)',
    favoriteItem: {
      addToCartButton: 'Dodaj do koszyka',
      showConfigurationButton: 'Pokaż konfigurację',
      shoppingCartItemPanel: shoppingCartItemPanelTranslation,
      shoppingCartItemBasicInfo: shoppingCartItemBasicInfoTranslation,
    },
    editConfigurationNameModal: {
      header: 'Edytuj nazwę',
      description: 'Oznacz swoją konfigurację nazwą klienta, datą lub inną cechą',
      configurationNameLabel: 'Nazwa konfiguracji',
      saveButton: 'Zapisz',
      shoppingCartItemPanel: shoppingCartItemPanelTranslation,
      shoppingCartItemBasicInfo: shoppingCartItemBasicInfoTranslation,
    },
    favoriteItemDetailsModal: {
      configurationText: 'Konfiguracja',
      accessoriesText: 'Akcesoria',
      shoppingCartItemPanel: shoppingCartItemPanelTranslation,
      shoppingCartItemBasicInfo: shoppingCartItemBasicInfoTranslation,
    },
    removalConfirmationModal: {
      header: 'Usuń z ulubionych',
      description: 'Czy na pewno chcesz usunąć produkt z ulubionych?',
      confirmButton: 'Tak, usuń',
      shoppingCartItemPanel: shoppingCartItemPanelTranslation,
      shoppingCartItemBasicInfo: shoppingCartItemBasicInfoTranslation,
    },
    emptyFavoritesList: {
      titleText: 'Lista Twoich ulubionych jest pusta',
      subtitleText: "ale nie musi być",
      labelText: 'Przeglądaj produkty',
    },
  },
  loginPage: {
    welcomeText: 'Witaj w Flokk Hub!',
    getStartedButton: 'Rozpocznij',
  },
  orderPage: {
    downloadImagesLabel: 'Pobierz wizualizacje',
    shippingWithinTextFormat: 'Wysyłka w ciągu {minDays} - {maxDays} dni roboczych',
    shippingSoonText: 'Wysyłka wkrótce',
    weHaveDelayText: 'Wystąpiło opóźnienie',
    changeInOrderAlertText: 'Wystąpiła zmiana w Twoim zamówieniu, poniższe informacje mogą być nieprawidłowe.',
    orderActionButtons: {
      yourReferenceLabel: 'Twój numer referencyjny',
      orderNameLabel: 'Nazwa zamówienia',
      setOrderNameText: 'Ustaw nazwę zamówienia',
      addEntireOrderToCartButton: 'Dodaj całe zamówienie do koszyka',
    },
    trackingInformation: {
      trackOrderButton: 'Śledź zamówienie',
    },
    shippingDate: {
      shippingDateText: 'Data wysyłki',
      shippingTimeText: 'Czas wysyłki',
      withinDaysTextFormat: 'w ciągu {minDays} - {maxDays} dni roboczych',
      soonText: 'Wkrótce',
      delayText: 'Wystąpiło opóźnienie',
    },
    orderDetailsPanel: {
      deliveryAddressLabel: 'Adres dostway',
      totalPriceBeforeVatLabel: 'Cena całowita bez VAT-u',
      totalPriceIncludingVatLabel: 'Cena całkowita z VAT-em',
      buyerLabel: 'Kupujący',
      summaryLabel: 'Podsumowanie',
      summary: cartSummaryTranslation,
    },
    orderDetailsProduct: {
      reorderButton: 'Zamówi ponownie',
      productsHeader: 'Produkty',
      shoppingCartItemPanel: shoppingCartItemPanelTranslation,
      shoppingCartItemBasicInfo: shoppingCartItemBasicInfoTranslation,
    },
    orderShipmentsModal: {
      closeButton: 'Zamknij',
      header: 'Dostawa składa się z kilku przesyłek',
      orderShipmentPanelHeader: {
        deliveryNumberLabel: 'Numer zamówiewnia ',
        shippingDateLabel: 'Data zamówienia: ',
        trackOrderButton: 'Śledź zamówienie',
      },
      orderShipmentsList: {
        configurationCodeLabel: 'Kod kofiguracyjny',
      },
    },
    editOrderModal: {
      orderTextFormat: 'Zamówienie {orderNumber}',
      saveButton: 'Zapisz',
      nameLabel: 'Nazwa',
    },
    reorderModal: {
      areYouSureText: 'Czy na pewno chcesz dodać zawartość zamówienia do koszyka?',
      confirmButton: 'Potwierdź',
      orderTextFormat: 'Zamówienie {orderNumber}',
    },
  },
  quickOrderPage: {
    pageDescriptionFormat: 'Opis',
    pageTitleFormat: 'Szybkie zamówienie',
    title: 'Wpisz kod swojej konfiguracji',
    description: 'i zostaniesz przeniosiony do konfiguratora.',
    codeInputPlaceholder: 'Wpisz kod tutaj i naciśnij Enter.',
    configurationFinder: {
      codeWithIncorrectLengthFormat: 'Kod musi mieć dokładnie 6 znaków, lub 6 znaków poprzedzonych "M-" dla konfiguracji modułowej.',
      codeInvalid: 'Podany kod {invalidCode} jest nieprawidłowy! Upewnij się, że został wpisany poprawnie.',
      codeNotFound: 'Nie jesteśmy w stanie znaleźć konfiguracji o kodzie {notFoundCode}.',
    },
  },
  ordersPage: {
    title: "Historia zamówień",
    ongoingOrdersTitle: 'Aktualne zamówienia',
    pastOrdersTitle: 'Poprzednie zamówienia',
    ordersListFilter: {
      searchLabel: 'Szukaj',
      searchPlaceholder: 'Numer lub nazwa zamówienia',
      onlyMineLabel: 'Tylko moje',
      dateLabel: 'Data',
      searchButton: 'Szukaj',
      resetButton: 'Resetuj',
      sortByLabel: 'Sortuj po',
      sortByOrderNumberAscLabel: 'Numer zamówienia (rosnąco)',
      sortByOrderNumberDescLabel: 'Numer zamówienia (malejąco)',
      sortByOrderDateAscLabel: 'Data zamówienia (rosnąco)',
      sortByOrderDateDescLabel: 'Data zamówienia (malejąco)',
      sortByOrderTotalAscLabel: 'Całkowita wartość zamówienia (rosnąco)',
      sortByOrderTotalDescLabel: 'Całkowita wartość zamówienia (malejąco)',
    },
    tabContent: {
      noOrdersMatchingCriteriaText: 'Brak zamówień spełniających Twoje kryteria.',
      pastOrdersTable: {
        orderNumberHeader: 'Numer zamówienia',
        orderNameHeader: 'Nazwa zaówienia',
        orderDateHeader: 'Data zamówienia',
        shippingDateHeader: 'Data wysyłki',
        productsHeader: 'Produkty',
        totalPriceHeader: 'Cena całkowita',
        buyerHeader: 'Kupujący',
        cancelledText: 'Anulowane',
      },
      order: {
        changesInOrderAlertText: 'Wystąpiła zmiana w Twoim zamówieniu, poniższe informacje mogą być nieprawidłowe.',
        shippingDateFormat: 'Data wysyłki {date}',
        orderHeader: {
          orderNoLabel: 'Numer zamówienia',
          orderDateLabel: 'Data zamówienia',
          totalPriceLabel: 'Cena całkowita',
          buyerLabel: 'Kupujący',
          orderNameLabel: 'Nazwa zamówienia',
          yourReferenceLabel: 'Twój numer referencyjny',
        },
        orderItem: {
          cartItemDetails: cartItemDetailsTranslation,
        },
        shippingMessage: {
          shippingSoonText: 'Wkrótce wysyłka',
          shippingWithinDaysFormat: 'Wysyłka w ciągu {minDays} - {maxDays} dni pracy',
          weHaveDelayText: 'Wystąpiło pewne opóźnienie',
        },
      },
    },
  },
  sideMenu: {
    legacyProductsLabel: 'Produkty',
    legacyFavoritesLabel: 'Moje ulubione',
    pricelistsLabel: 'Produkty',
    productsLabel: 'Konfiguruj',
    favoritesLabel: 'Ulubione',
    quickOrderLabel: 'Szybkie zamówienie',
    orderHistoryLabel: 'Historia zamówień',
    termsLabel: 'Warunki handlowe',
    signOutLabel: 'Wyloguj',
  },
  topMenu: {
    cartButton: 'Koszyk',
    userInfo: {
      pricingContextFormat: 'Wszystkie ceny {currency} (bez VAT)',
      storeSelector: {
        searchPlaceholder: 'Wprowadź nazwę lub numer ID',
        clearSearchButton: 'Wyczyść wyszukiwanie',
        storeChangeFailedWarning: {
          message: 'Przepraszamy, nie jesteśmy w stanie zmienić Twojej aktualnej organizacji na wybraną. Proszę spróbować ponownie lub skontaktować się ze wsparciem klienta.'
        },
        noSearchResultsText: 'Nie znaleziono pasujących klientów'
      }
    }
  },
  appLoader: {
    loaderText: 'Ładowanie...',
  },
};

export default translation;
